import React from 'react';
import PropTypes from 'prop-types';
import ThemePageBanner from '../dashboardNew/components/ThemePageBanner';

export default function HeroSlice(props) {
    const {
        background_image,
        headline,
    } = props.data;

    return (
        <ThemePageBanner
             image={background_image}
             heading={headline}
         />
    )
}

HeroSlice.propTypes = {
    data: PropTypes.shape({
        background_options: PropTypes.string,
        background_image: PropTypes.string,
        headline: PropTypes.string,
        subtitle: PropTypes.string,
        text_alignment: PropTypes.string,
        type: PropTypes.string,
        buttons: PropTypes.arrayOf(PropTypes.shape({
            button_type: PropTypes.string,
            button_color: PropTypes.string,
            button_text: PropTypes.string,
            button_link: PropTypes.string
        }))
    }),
}



// WEBPACK FOOTER //
// src/client/components/slices/HeroSlice.js